import React from 'react';
import { motion } from 'framer-motion';
import { useTestStore } from '../../store/testStore';
import { getIconComponent } from '../../data/testData';

const CategoryNavigation: React.FC = () => {
  const { categories, currentCategoryIndex, goToCategory, answers } = useTestStore();
  
  // Calculate completion percentage for each category
  const getCategoryCompletion = (categoryId: string) => {
    const category = categories.find(c => c.id === categoryId);
    if (!category) return 0;
    
    const answeredQuestions = category.questions.filter(q => 
      answers[q.id] !== undefined
    ).length;
    
    return (answeredQuestions / category.questions.length) * 100;
  };
  
  return (
    <div className="bg-white rounded-lg shadow-card p-4">
      <h3 className="font-bold text-gray-800 mb-4">Test Categories</h3>
      
      <div className="space-y-2">
        {categories.map((category, index) => {
          const IconComponent = getIconComponent(category.icon);
          const isActive = index === currentCategoryIndex;
          const completionPercentage = getCategoryCompletion(category.id);
          
          return (
            <motion.button
              key={category.id}
              className={`w-full flex items-center p-3 rounded-lg text-left transition-all ${
                isActive 
                  ? 'bg-primary-50 text-primary-700 border-l-4 border-primary-600' 
                  : 'hover:bg-gray-50 text-gray-700'
              }`}
              onClick={() => goToCategory(index)}
              whileHover={{ x: isActive ? 0 : 4 }}
              whileTap={{ scale: 0.98 }}
            >
              <IconComponent className={`h-5 w-5 mr-3 ${isActive ? 'text-primary-600' : 'text-gray-500'}`} />
              
              <div className="flex-1">
                <div className="flex justify-between mb-1">
                  <span className={`font-medium ${isActive ? 'text-primary-700' : 'text-gray-700'}`}>
                    {category.title}
                  </span>
                  <span className="text-xs text-gray-500">
                    {Math.round(completionPercentage)}%
                  </span>
                </div>
                
                <div className="w-full bg-gray-200 h-1 rounded-full overflow-hidden">
                  <motion.div
                    className="bg-primary-500 h-full"
                    initial={{ width: 0 }}
                    animate={{ width: `${completionPercentage}%` }}
                    transition={{ duration: 0.5 }}
                  />
                </div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryNavigation;